/**
 * Timezone-aware clock helpers.
 *
 * The app's audience is in Romania, but visitors' devices can be set to any
 * timezone. To decide copy like "Tonight" vs "Today" we need the *Romanian*
 * wall-clock hour, not the device's. `Intl` does the heavy lifting (and handles
 * DST for Europe/Bucharest) with no extra dependency.
 */

const BUCHAREST_HOUR = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Europe/Bucharest",
  hour: "2-digit",
  hour12: false,
});

/** The current hour (0–23) in Romania for the given instant (default: now). */
export function hourInBucharest(now: Date = new Date()): number {
  // "24" can surface at midnight in some engines — normalise it to 0.
  const hour = Number(BUCHAREST_HOUR.format(now));
  return Number.isNaN(hour) ? now.getHours() : hour % 24;
}

/** True once it's 17:00 or later in Romania — the "tonight" cutover. */
export function isEveningInRomania(now: Date = new Date()): boolean {
  return hourInBucharest(now) >= 17;
}
